export const planDraft: string = `
<h3>このプランでできる体験は？</h3>

<blockquote><p>プランの推しを端的に表現するセクションです。魅力を端的に表す言葉を見出しにして、定性的な体験価値を記載しましょう。</p></blockquote>
<p>(例)自然豊かな磯崎は隠れた食材の宝庫として料理人の間などでは知られています。<br>HOTEL ABCでは季節に合わせて磯崎の地のものにできるだけ手を加えずに食材の本来の味を引き立てるお料理を提供しています。
<br>ヒノキの一枚板のテーブルの上で四季折々の磯崎の味をお愉しみください。</p>

<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1609201705853.png">体験が想像できる写真を1-2枚入れましょう</h6>

<h3>プランの詳細は？</h3>

<blockquote><p>プランの詳細を簡潔に記載しましょう。メニュー例や写真などがあると体験が想起できるのでゲストが予約しやすいです。</p>

</blockquote><blockquote><p>(例)秋のメニュー例<br>・秋秋刀魚の塩焼き<br>・~~~~<br>・~~~~</p></blockquote>

<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1609201815275.png">体験が想像できる写真を1-2枚入れましょう</h6>

<h3><strong>プランの注意点は？</strong></h3>
<blockquote><p>予約にあたっての注意事項を記載して、ゲストの不安点を解消しましょう。</p></blockquote>
<p>(例)ご注意事項<br>ご夕食は19時 - 21時の間に承っております。<br>季節やその日の都合により食材が変わることがございます。<br>アレルギー等がございましたら、予約決済画面にてご記載ください</p>`;
